import { AxiosRequestConfig } from "axios"
import { HttpClient } from "~/api/HttpClient"

export const API_PREFIX_POST_PATH = "/api/tours"
// export const API_PREFIX_TAG_PATH = "/api/tags"

export const fetchTours = async (filter: { searchValue?: string; category?: number }) => {
  const params: AxiosRequestConfig["params"] = {
    sort: "is_new:DESC",
    populate: "*",

    filters: {
      $and: [
        {
          category: {
            id: {
              $containsi: filter.category,
            },
          },
        },
        {
          $or: [
            {
              tags: {
                name: {
                  $containsi: filter.searchValue,
                },
              },
            },
            {
              title: {
                $containsi: filter.searchValue,
              },
            },
          ],
        },
      ],
    },
  }

  return await HttpClient.get(`${API_PREFIX_POST_PATH}`, { params })
}

// export const fetchPostByCategories = async (categoriesId: string[]) => {
//   const params: FilterSearchParams = {
//     populate: "*",
//     sort: "createdAt:desc",
//     publicationState: "live",
//     filters: {
//       categories: {
//         // @ts-ignore
//         id: {
//           $in: categoriesId,
//         },
//       },
//     },
//     pagination: {
//       pageSize: "100",
//     },
//   }

//   try {
//     const response = await HttpClient.get(`${API_PREFIX_POST_PATH}`, { params })

//     const modifiedResponse = response.data.map((post: any) => ({
//       ...post,
//       status: post.attributes.publishedAt ? "published" : "draft",
//       publishedAt: post.attributes.publishedAt,
//     }))

//     return {
//       data: modifiedResponse,
//       meta: response.meta,
//     }
//   } catch (error) {
//     message.error("Không thể lấy bài viết. Vui lòng thử lại.")
//   }
// }

// export const fetchPosts = async (searchTerms: { [key: string]: string } = {}) => {
//   const params: FilterSearchParams = {
//     populate: "*",
//     sort: "createdAt:desc",
//     publicationState: "preview",
//     filters: {},
//     pagination: {
//       pageSize: "100",
//     },
//     locale: localStorage.getItem("language") || undefined,
//   }
//   const excludedKeys = ["current", "pageSize", "start", "limit", "total", "page"]

//   Object.keys(searchTerms).forEach(key => {
//     const value = searchTerms[key]

//     if (key === "publicationState") {
//       const convertParamStatusPost = value === "draft" || value === "all" ? "preview" : "live"
//       params.publicationState = convertParamStatusPost

//       if (value === "draft") {
//         params.filters.publishedAt = { $null: true }
//       } else {
//         delete params.filters.publishedAt
//       }
//     } else if (key === "locale") {
//       params.locale = value
//     } else if (!excludedKeys.includes(key)) {
//       if (key === "category") {
//         params.filters.category = { $eq: value }
//       } else {
//         if (value) {
//           params.filters[key] = { $containsi: value }
//         }
//       }
//     } else if (value) {
//       params.pagination = {
//         ...params.pagination,
//         [key]: value,
//       }
//     }
//   })

//   try {
//     const response = await HttpClient.get(`${API_PREFIX_POST_PATH}`, { params })
//     const modifiedResponse = response.data.map((post: any) => ({
//       ...post,
//       status: post.attributes.publishedAt ? "published" : "draft",
//       publishedAt: post.attributes.publishedAt,
//     }))

//     return {
//       data: modifiedResponse,
//       meta: response.meta,
//     }
//   } catch (error) {
//     message.error("Không thể lấy bài viết. Vui lòng thử lại.")
//   }
// }

// export const fetchPostId = async (id: number) => {
//   const response = await HttpClient.get(`${API_PREFIX_POST_PATH}/${id}?populate=*`)
//   return response.data
// }

// export const deletePost = async (id: number) => {
//   return await HttpClient.delete(`${API_PREFIX_POST_PATH}/${id}`)
// }
// export const updatePost = async (id: number, data: any) => {
//   return await HttpClient.put(`${API_PREFIX_POST_PATH}/${id}`, data)
// }
// export const addPost = async (data: any) => {
//   return await HttpClient.post(`${API_PREFIX_POST_PATH}`, data)
// }

// export const fetchCategories = async () => {
//   return await HttpClient.get(`/api/cateogries`)
// }

// export const fetchTags = async () => {
//   return await HttpClient.get(`/api/tags`)
// }

// export const createTag = async (data: AttributesCategory) => {
//   return await HttpClient.post(`${API_PREFIX_TAG_PATH}`, { data })
// }

// export const checkSlug = async (slug: string) => {
//   const params: AxiosRequestConfig["params"] = {
//     filters: {
//       slug: { $eq: slug },
//     },
//     publicationState: "preview",
//   }
//   return await HttpClient.get(`${API_PREFIX_POST_PATH}`, { params })
// }
